import React from "react";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";

import images from "../../assets/img/images";
import EllipsedTextNew from "./EllipsedTextNew";

const styles = {
  colorRect: {
    marginRight: "5px",
    borderRadius: "2px",
  },
};

const TagColor = (props) => {
  const { classes, size = 14 } = props;

  const color =
    props.color && props.color.includes("#") ? props.color : `#${props.color}`;

  const tagColor = (
    <Grid
      item
      className={classes.colorRect}
      style={{
        backgroundColor: color,
        width: `${size}px`,
        minWidth: `${size}px`,
        maxWidth: `${size}px`,
        height: `${size}px`,
      }}
    >
      {(!props.color || props.color.includes("undefined")) && (
        <img src={images.noTag} alt="no_tag" height={size} />
      )}
    </Grid>
  );

  if (props.name) {
    return (
      <Grid container alignItems="center" wrap="nowrap">
        {tagColor}
        <Grid item className="text-54" style={props.style}>
          {props.maxWidth ? (
            <EllipsedTextNew text={props.name} maxWidth={props.maxWidth} />
          ) : (
            props.name
          )}
        </Grid>
      </Grid>
    );
  }

  return tagColor;
};

TagColor.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

export default withStyles(styles)(TagColor);
